import { render, staticRenderFns } from "./studentGroupComponent.vue?vue&type=template&id=00e8cc0e&"
import script from "./studentGroupComponent.vue?vue&type=script&lang=js&"
export * from "./studentGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./studentGroupComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports